import classNames from 'classnames'
import type React from 'react'
import { useTracking } from 'swisscard/components/form/hooks/use_tracking'
import type { TrackingProps } from '../../../tracking/types'
import { buttonStyles } from './button_styles'

import type { FC, ReactNode } from 'react'

type AbstractButtonPropsType = {
  component?: keyof JSX.IntrinsicElements
  href?: string
}

const AbstractButton: FC<AbstractButtonPropsType> = ({ component: Tag = 'button', children, ...others }) => (
  <Tag tabIndex={0} {...others}>
    {children}
  </Tag>
)

type StyledButtonProps = {
  borderless?: boolean
  children: ReactNode
  className?: string
  primary?: boolean
  component?: keyof JSX.IntrinsicElements
  disabled?: boolean
  fullWidth?: boolean
  htmlFor?: string
  loading?: boolean
  tabIndex?: number | undefined
  type?: 'button' | 'submit'
  next?: boolean
  back?: boolean
  href?: string
  onClick?: (event: any) => void
  onKeyDown?: (event: React.KeyboardEvent<any>) => void
  onKeyUp?: (event: React.KeyboardEvent<any>) => void
}

export const StyledButton = (props: StyledButtonProps & TrackingProps) => {
  const buttonProps = useTracking(props, {
    event: props.trackingDetails?.event || 'ctaSelected',
    action: 'onClick',
    ctaValue: typeof props.children === 'string' ? props.children : undefined,
  })
  const {
    back,
    borderless,
    children,
    component,
    fullWidth,
    href,
    loading,
    next,
    primary,
    hasTracking,
    errorMessage,
    displayErrors,
    ...other
  } = buttonProps

  const classes = buttonStyles()
  const buttonClasses = classNames(
    classes.button,
    { [classes.buttonLoading]: loading },
    { [classes.buttonPrimary]: primary },
    { [classes.borderless]: borderless },
    { [classes.fullWidth]: fullWidth },
    { [classes.buttonNext]: next },
    { [classes.buttonBack]: back },
  )

  return (
    <AbstractButton className={buttonClasses} component={href ? 'a' : component} href={href} {...other}>
      {children}
    </AbstractButton>
  )
}
